

















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'cIconArrowTableDown',
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(_, context) {
    const onClickEvent = (event: MouseEvent): void => {
      context.emit('on-icon-click', event);
    };

    return {
      onClickEvent,
    };
  },
});
